export default "__VITE_ASSET__qScdEgSp__"